import React from "react"
import Link from 'gatsby-link'
import Helmet from "react-helmet"
import styled from "styled-components"

import SEO from "../components/SEO/SEO"
import config from "../../data/SiteConfig"
import MainHeader from '../components/Layout/Header'
import About from '../components/About/About'
import imgQuickstart from "./laptop.jpg"
// import imgData from './data.jpg'


class GuidesPage extends React.Component {
  render() {
    return (
      <div className="index-container">
        <Helmet title={config.siteTitle} />
        <main>
          <MainHeader
            siteTitle={config.siteTitle}
            siteDescription={config.siteDescription}
            location={this.props.location}
            logo={config.siteLogo}
          />
          <BodyContainer>
            <div className="wrapper">
              {/* <h1>Parallax Flipping Cards</h1> */}

              <div className="cols">
                  {/* <div className="col" ontouchstart="this.classList.toggle('hover');">
                    <div className="container">
                      <div className="front" style={{backgroundImage: "url(https://unsplash.it/500/500/)"}}>
                        <div className="inner">
                          <p>Blog</p>
                          <span>Lorem ipsum</span>
                        </div>
                      </div>
                      <div className="back">
                        <div className="inner">
                          <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Alias cum repellat velit quae suscipit c.</p>
                        </div>
                      </div>
                    </div>
                  </div> */}
                      <div className="col" ontouchstart="this.classList.toggle('hover');">
                        <a target="_blank" href="https://www.gecho.org/guide/quickstart">
                            <div className="container">
                              <div className="front" style={{backgroundImage:`url(${imgQuickstart})`}}>
                                <div className="inner">
                                  <p>Quick Start</p>
                                  <span>Setup your Mac</span>
                                </div>
                              </div>
                              <div className="back">
                                <div className="inner">
                                  <p>Quickstart guide for getting your machine configured for GEHCO work</p>
                                </div>
                              </div>
                            </div>
                        </a>
                      </div>


                  <div className="col" ontouchstart="this.classList.toggle('hover');">
                    <div className="container">
                      <div className="front" style={{backgroundColor:"grey"}}>
                        <div className="inner">
                          <p>GIS</p>
                          <span>Geographic Information Systems</span>
                          <br />
                          <span>(Coming Soon)</span>
                        </div>
                      </div>
                      <div className="back">
                        <div className="inner">
                          <p>An illustrated tour of Geographic Information Systems (GIS)</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col" ontouchstart="this.classList.toggle('hover');">
                    <div className="container">
                      <div className="front" style={{backgroundColor:"grey"}}>
                        <div className="inner">
                          <p>Machine Learning</p>
                          <span>Programmatic approaches to data insights</span>
                          <br />
                          <span>(Coming Soon)</span>
                        </div>
                      </div>
                      <div className="back">
                        <div className="inner">
                          <p>Ways to use machine learning to explore GECHO data</p>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
             </div>

           </BodyContainer>
        </main>
      </div>
    );
  }
}

export default GuidesPage;

const BodyContainer = styled.div`
  padding: ${props => props.theme.sitePadding};
  max-width: ${props => props.theme.contentWidthLaptop};
  margin: 0 auto;

  *{
    margin: 0;
    padding: 0;
    -webkit-box-sizing: border-box;
            box-sizing: border-box;
  }

  h1{
    font-size: 2.5rem;
    font-family: 'Montserrat';
    font-weight: normal;
    color: #444;
    text-align: center;
    margin: 2rem 0;
  }

  .wrapper{
    width: 90%;
    margin: 0 auto;
    max-width: 80rem;
  }

  .cols{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
  }

  .col{
    width: calc(25% - 2rem);
    margin: 1rem;
    cursor: pointer;
  }

  .container{
    -webkit-transform-style: preserve-3d;
            transform-style: preserve-3d;
  	-webkit-perspective: 1000px;
  	        perspective: 1000px;
  }

  .front,
  .back{
    background-size: cover;
  	background-position: center;
  	-webkit-transition: -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);
  	transition: -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);
  	-o-transition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);
  	transition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);
  	transition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1), -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);
  	-webkit-backface-visibility: hidden;
  	        backface-visibility: hidden;
  	text-align: center;
  	min-height: 280px;
  	height: auto;
  	border-radius: 10px;
  	color: #fff;
  	font-size: 1.5rem;
  }

  .back{
    ${'' /* background: #cedce7; */}
    background: #55786C;
    background: -webkit-linear-gradient(45deg,  #55786C 0%,#596a72 100%);
    background: -o-linear-gradient(45deg,  #55786C 0%,#596a72 100%);
    background: linear-gradient(45deg,  #55786C 0%,#596a72 100%);
  }

  .front:after{
  	position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      content: '';
      display: block;
      opacity: .4;
      ${'' /* background-color: #000; */}
      background-color: #55786C;
      -webkit-backface-visibility: hidden;
              backface-visibility: hidden;
      border-radius: 10px;
  }
  .container:hover .front,
  .container:hover .back{
      -webkit-transition: -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);
      transition: -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);
      -o-transition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);
      transition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);
      transition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1), -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);
  }

  .back{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
  }

  .inner{
      -webkit-transform: translateY(-50%) translateZ(60px) scale(0.94);
              transform: translateY(-50%) translateZ(60px) scale(0.94);
      top: 50%;
      position: absolute;
      left: 0;
      width: 100%;
      padding: 2rem;
      -webkit-box-sizing: border-box;
              box-sizing: border-box;
      outline: 1px solid transparent;
      -webkit-perspective: inherit;
              perspective: inherit;
      z-index: 2;
  }

  .container .back{
      -webkit-transform: rotateY(180deg);
              transform: rotateY(180deg);
      -webkit-transform-style: preserve-3d;
              transform-style: preserve-3d;
  }

  .container .front{
      -webkit-transform: rotateY(0deg);
              transform: rotateY(0deg);
      -webkit-transform-style: preserve-3d;
              transform-style: preserve-3d;
  }

  .container:hover .back{
    -webkit-transform: rotateY(0deg);
            transform: rotateY(0deg);
    -webkit-transform-style: preserve-3d;
            transform-style: preserve-3d;
  }

  .container:hover .front{
    -webkit-transform: rotateY(-180deg);
            transform: rotateY(-180deg);
    -webkit-transform-style: preserve-3d;
            transform-style: preserve-3d;
  }

  .front .inner p{
    font-size: 3rem;
    margin-bottom: 2rem;
    position: relative;
  }

  .front .inner p:after{
    content: '';
    width: 4rem;
    height: 2px;
    position: absolute;
    background: #C6D4DF;
    display: block;
    left: 0;
    right: 0;
    margin: 0 auto;
    bottom: -.75rem;
  }

  .front .inner span{
    color: rgba(255,255,255,0.7);
    font-family: 'Montserrat';
    font-weight: 300;
    font-size: 2rem;
  }

  @media screen and (max-width: 164rem){
    .col{
      width: calc(33.333333% - 2rem);
    }
  }

  @media screen and (max-width: 48rem){
    .col{
      width: calc(50% - 2rem);
    }
  }

  @media screen and (max-width: 32rem){
    .col{
      width: 100%;
      margin: 0 0 2rem 0;
    }
  }

`



// WEBPACK FOOTER //
// ./src/pages/guides.jsx